module.exports = __webpack_public_path__ + "img/envirothon_logo.984a7016.png";